const EXPERIMENT_REGEX = /^[a-z0-9]+([A-Z]{1}[a-z0-9]+)*(\d{4}-\d{2}-\d{2})$/;

export const extractExperimentParams = (search: string) =>
  [...new URLSearchParams(search).entries()].reduce<Record<string, string>>(
    (acc, [param, value]) => {
      if (param.match(EXPERIMENT_REGEX)) {
        acc[param] = value;
      }
      return acc;
    },
    {},
  );
